export default __webpack_public_path__ + "static/media/bike.2a2045c6.png";